import { render, staticRenderFns } from "./Form19Layout.vue?vue&type=template&id=acfccaa4&scoped=true"
import script from "./Form19Layout.vue?vue&type=script&lang=ts"
export * from "./Form19Layout.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=acfccaa4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfccaa4",
  null
  
)

export default component.exports